import React from 'react';
import { capitalize, Text } from 'UI/Text';
import { WithTooltip } from 'UI/Tooltip';

export const DescriptionText = ({ text, title }: { text: string; title?: boolean }) => {
  return (
    <WithTooltip title={capitalize(text)} placement={'top'}>
      <Text type="base" bold={!title} ellipsis>
        {capitalize(text)}
      </Text>
    </WithTooltip>
  );
};
